import _ from 'lodash';
import dayjs from 'dayjs';

/**
 * Flattens an array of email messages into quoted HTML format, sorted newest-first.
 * Each message is wrapped in a standard email quoting style with headers and body.
 *
 * @param {Array} messages - Array of email message objects from the conversation
 * @returns {string} HTML string with all messages formatted as quoted blocks
 */
function flattenThread(messages) {
    if (!messages || messages.length === 0) return '';

    const sorted = _.orderBy(messages, m => dayjs(m.receivedDateTime).valueOf(), 'desc');

    return sorted.map(msg => {
        const senderName = msg.sender?.emailAddress?.name || '';
        const senderAddress = msg.sender?.emailAddress?.address || '';
        const date = msg.receivedDateTime ? dayjs(msg.receivedDateTime).format('DD/MM/YYYY HH:mm') : '';
        const toList = (msg.toRecipients || [])
            .map(r => r?.emailAddress?.name ? `${r.emailAddress.name} &lt;${r.emailAddress.address}&gt;` : r?.emailAddress?.address || '')
            .filter(Boolean)
            .join(', ');
        const subject = msg.subject || '';
        const body = msg.body?.content || '';

        return `<div style="padding-left: 10px; border-left: 2px solid #ccc; color: #555; margin-top: 10px;">
  <div style="margin-bottom: 8px; font-size: 11px;">
    <b>From:</b> ${senderName}${senderAddress ? ` &lt;${senderAddress}&gt;` : ''}<br/>
    <b>Date:</b> ${date}<br/>
    <b>To:</b> ${toList}<br/>
    <b>Subject:</b> ${subject}<br/>
  </div>
  <div>${body}</div>
</div>`;
    }).join('');
}

export default flattenThread;
